import type { DerivedChange, DerivedKey } from '../../core/stats';
import type { Element, Stats } from '../../data/schema';

/** Libellés façon Isaac des stats dérivées (lecture rapide), avec le pictogramme Dofus correspondant. */
export const DERIVED_LABEL: Record<DerivedKey, string> = {
  attackSpeed: 'Vitesse d’attaque', damage: 'Dégâts', projectileSpeed: 'Vitesse des projectiles', moveSpeed: 'Vitesse de déplacement',
  range: 'Portée', projectiles: 'Projectiles', hpMax: 'PV max', xpMult: 'Gain d’XP',
};
export const STAT_LABEL: Record<keyof Stats, string> = { vitalite: 'Vitalité', force: 'Force', intelligence: 'Intelligence', agilite: 'Agilité', chance: 'Chance', sagesse: 'Sagesse' };
export const ELEMENT_LABEL: Record<Element, string> = { feu: 'Feu', air: 'Air', eau: 'Eau', terre: 'Terre', neutre: 'Neutre' };

/** Nombre en français (virgule décimale), sans zéros inutiles au-delà de `decimals`. */
export function fr(n: number, decimals = 2): string {
  return n.toFixed(decimals).replace('.', ',');
}
export const mult = (m: number): string => `×${fr(m)}`;
const signed = (n: number, suffix: string): string => `${n > 0 ? '+' : n < 0 ? '-' : ''}${fr(Math.abs(n), 1).replace(/,0$/, '')}${suffix}`;

/** « +17,6 % Vitesse d’attaque », « +1 projectile », « +40 PV max ». */
export function changeText(c: DerivedChange): string {
  if ('pct' in c) return `${signed(c.pct, ' %')} ${DERIVED_LABEL[c.key]}`;
  if (c.key === 'projectiles') return `${signed(c.delta, '')} projectile${Math.abs(c.delta) > 1 ? 's' : ''}`;
  return `${signed(c.delta, '')} ${DERIVED_LABEL[c.key]}`;
}
